module.exports = __webpack_public_path__ + "img/peh33_device_halo.ae235a7f.png";